<template>
  <c-view>
    <c-navbar title="绑定成功"></c-navbar>
    <c-page class="bg-color gray">
      <c-content>
        <div class="text-center card-bind-result">
          <div class="card-info-panel">
            <div class="success-icon"><i class="text-color orange s-icon-check-circle-success"></i></div>
            <div class="item-title">{{cardName}}已到账</div>
            <div class="text-color gray">管理好产品是经营的第一要务哟 </div>
            <c-button class="mt-20 add-new-goods" @click.native="addNewGoods">添加商品
            </c-button>
          </div>
          <div class="text-color dark-gray">
            需要帮助？ <br>
            搜索微信号：<span class="text-color orange">syhao518</span>，专属客服为您解答！
          </div>
        </div>
      </c-content>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  export default {
    data () {
      return {
        cardName: ''
      }
    },
    components: {},
    created () {
    },
    mounted () {
      this.cardName = this.$route.query.name
      console.log('cardName', this.cardName)
    },
    beforeDestroy () {
    },
    methods: {
      addNewGoods () {
        // 打开添加商品
        window.$fe_bridge.page.addGoods()
      }
    },
    computed: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?71d20839